import React from 'react'
import { TagContainer, TagText } from './styles'
import { ITimelineMaternalInfant } from '~/interfaces'
import { theme } from '~/styles'

interface MaternalInfantTagOfSelectedTimelineProps {
  patientType: ITimelineMaternalInfant.PatientType
  children: string
}

export const MaternalInfantTagOfSelectedTimeline = ({
  patientType,
  children
}: MaternalInfantTagOfSelectedTimelineProps): JSX.Element => {
  const BabyTag = (): JSX.Element => {
    return (
      <TagContainer color={theme.colors.color378ff7}>
        <TagText>{children}</TagText>
      </TagContainer>
    )
  }
  const MotherTag = (): JSX.Element => {
    return (
      <TagContainer color={theme.colors.color005597}>
        <TagText>{children}</TagText>
      </TagContainer>
    )
  }

  if (patientType === 'mother') return <MotherTag />
  return <BabyTag />
}
